import React, { useState, useEffect, useContext } from "react";
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Button,
} from "@mui/material";
import {
    ModeEditOutlineOutlined,
} from "@mui/icons-material";
import AsyncSelect from "react-select/async";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";
import blogFetch from "../../../../axios/config";
import { DateTimeFmt } from "../../../../utils/DataUtils";
import { useNavigate } from 'react-router-dom';
import { IGSA } from "../GSAModal";


const INITIAL_MODAL = {
    isShow: false,
    title: "",
    body: ""
}

interface IDefeitoGSA {
    defeito_Key: number;
    defeito_Descricao: string;
    defeito_Ativo: boolean;
    _Mod: string;
    _ts_Mod: Date;
}

interface IDefeitoGSA {
    defeito_Key: number;
    defeito_Descricao: string;
    defeito_Ativo: boolean;
    _Mod: string;
    _ts_Mod: Date;
}

interface ISAGA_OrdensProducao {
    ordem_Part_Short: string;
    ordem_VehDesc: string;
    ordem_SetAtual: string;
}

interface IGSAList {
    gsA_Key: number;
    gsA_Ordem: string;
    gsA_Status: string;
    gsA_Defeito_Key: number;
    defeito: IDefeitoGSA | null;
    informacoes: ISAGA_OrdensProducao
    gsA_DataEntrada: string;
    _Mod: string | null;
    _Creat: string;
    _ts_Creat: string;
    _ts_Mod: string | null;
    setorRetrabalho?: ISetorRetrabalho;
    gsA_DataFinalizacao: string | null;
}

interface ISetorRetrabalho {
    setor_Key: number;
    setor_Ativo: boolean;
    setor_Descricao: string;
    _ts_Creat: string;
    _Creat: string;
    _ts_Mod: null;
    _Mod: null;
}

interface IiSAGA_Setores_Retrabalho_GSA {
    setor_Key: number;
    setor_Descricao: string;
    setor_Ativo: boolean;
    _Mod: string;
    _ts_Mod: Date;
}

function GSAList({ }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<IGSAList[]>([]);
    const [isGetPendencias, setIsGetPendencias] = useState(false);
    // const [showModal, setShowModal] = useState(INITIAL_MODAL);
    const [updatePendancy, setUpdatePendancy] = useState({});
    const [sectorStates, setSectorStates] = useState({ name: "" });
    const [selectedItem, setSelectedItem] = useState<IGSAList | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showModalAppointment, setShowModalAppointment] = useState(false);
    const [sectors, setSectors] = useState<IiSAGA_Setores_Retrabalho_GSA[]>([]);
    const [sector, setSector] = useState("");

    const [defects, setDefects] = useState<IDefeitoGSA[]>([]);
    const [defect, setDefect] = useState("");

    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const getDefectsList = async () => {
        try {
            setLoading(true);
            const response = await blogFetch.get(`/DefectsGSA/get`);
            setDefects(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (item: IGSAList) => {
        setSelectedItem(item);
        setDefect(item.defeito?.defeito_Key ? String(item.defeito.defeito_Key) : "");
        setShowModal(true);
    };

    const handleOpenApproveModal = (item: IGSAList) => {
        setSelectedItem(item);
        setShowApproveModal(true);
    };

    const handleCloseApproveModal = () => {
        setSelectedItem(null);
        setShowApproveModal(false);
    };

    const handleOpenAppointmentModal = (item: IGSAList) => {
        setSelectedItem(item);
        setShowModalAppointment(true);
    };

    const getSectors = async () => {
        try {
            setLoading(true);
            const response = await blogFetch.get(`/DefectsGSA/get/sectors`);
            setSectors(response.data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const gotoLoss = (item: IGSAList) => {
        navigate('/Apontamento_SAP', {
            state: {
                gsaOrder: item.gsA_Ordem,
                gsaSector: item.informacoes.ordem_SetAtual
            }
        });
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedItem(null);
        setDefect("");
    };

    const getDefects = async () => {
        try {
            setLoading(true);
            const response = await blogFetch.get(`/DefectsGSA/get/list`);
            setData(response.data.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        async function fetchData() {
            await getDefects();
            await getSectors();
            await getDefectsList();
        }
        fetchData();
    }, [])




    const reworkGSA = async (selectedItem: IGSAList) => {
        try {

            if (!defect) {
                toast.error("Selecione o defeito!");
                return;
            }

            if (selectedItem.gsA_Status == "Em analise") {
                if (!sector) {
                    toast.error("Selecione o setor de retrabalho!");
                    return;
                }
                var status2 = "RETRABALHO"
            }
            else
                var status2 = "Em analise"

            const gsa: IGSA = {
                GSA_Ordem: selectedItem.gsA_Ordem,
                GSA_Status: status2,
                GSA_Defeito_Key: Number(defect),
                GSA_SetorRetrabalho_Key: Number(sector) ?? null,
                _Creat: user.user_UserName ?? user.user_Matricula
            };
            const response = await blogFetch.post(`/DefectsGSA/rework`, gsa);
            if (response.data.success) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
            handleCloseModal();
            setSector("");
            await getDefects();
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
        }
    };

    const approveGSA = async (selectedItem: IGSAList) => {
        try {

            const gsa: IGSA = {
                GSA_Ordem: selectedItem.gsA_Ordem,
                GSA_Status: "LIBERADA",
                GSA_Defeito_Key: null,
                _Creat: user.user_UserName ?? user.user_Matricula
            };
            const response = await blogFetch.post(`/DefectsGSA/approve`, gsa);
            if (response.data.success) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
            handleCloseApproveModal();

            await getDefects();
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
        }
    };

    const tableList = ((filter: string) => {
        return <><Table>
            <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Ordem
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Peça
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Defeito
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Veiculo
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Setor
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Status
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Hora Entrada
                    </TableCell>

                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Horas Paradas
                    </TableCell>

                    {filter == "RETRABALHO" &&
                        (
                            <>
                                <TableCell
                                    align="center"
                                    className="row-header"
                                >
                                    Setor Retrabalho
                                </TableCell>
                            </>
                        )
                    }

                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Acoes
                    </TableCell>
                </TableRow>
            </TableHead>
            {loading ? (
                <TableBody>
                    <TableRow>
                        <div className="d-flex justify-content-center align-items-center"
                            style={{ margin: "30px 0px" }}
                        >
                            <center>
                                <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                            </center>
                        </div>
                    </TableRow>
                </TableBody>
            ) : (
                <TableBody>
                    {data.length
                        ? data.filter(x => x.gsA_Status == filter).map((item, index) => (
                            <TableRow key={index} >
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                    align="center"
                                >
                                    {item.gsA_Ordem}
                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.informacoes.ordem_Part_Short}

                                </TableCell>

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                    align="center"
                                >
                                    {item.defeito?.defeito_Descricao}
                                </TableCell>

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.informacoes.ordem_VehDesc}
                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.informacoes.ordem_SetAtual}
                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.gsA_Status}
                                </TableCell>

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {DateTimeFmt(item.gsA_DataEntrada)}

                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {Math.floor((new Date().getTime() - new Date(item.gsA_DataEntrada).getTime()) / (1000 * 60 * 60))}h

                                </TableCell>

                                {filter == "RETRABALHO" &&
                                    (
                                        <>
                                            <TableCell
                                                align="center"
                                                className="row-header"
                                            >
                                                {item.setorRetrabalho?.setor_Descricao ?? ""}
                                            </TableCell>
                                        </>
                                    )
                                }

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    <button
                                        onClick={() => handleOpenModal(item)}
                                        type="button"
                                        className={`btn btn-sm ${item.gsA_Status == "Em analise" ? "btn-warning" : "btn-primary"} me-2`}
                                    >
                                        {item.gsA_Status == "Em analise" ? "Retrabalho" : "Em analise"}
                                    </button>
                                    <button
                                        onClick={() => gotoLoss(item)}
                                        type="button"
                                        className="btn btn-sm btn-danger me-2"
                                    >
                                        Apontar perda
                                    </button>
                                    <button
                                        onClick={() => handleOpenApproveModal(item)}
                                        type="button"
                                        className="btn btn-sm btn-success"
                                    >
                                        Liberar
                                    </button>
                                </TableCell>
                            </TableRow>
                        ))
                        : (
                            <TableRow>
                                <TableCell
                                    className="row-header"
                                    sx={{ textAlign: "center" }}
                                    rowSpan={5}
                                >
                                    Nao encontrado
                                </TableCell>
                            </TableRow>
                        )}
                </TableBody>
            )}
        </Table>
        </>
    })

    return (

        <>

            {showModal && selectedItem &&
                (
                    <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5">

                                        {selectedItem.gsA_Status == "Em analise" ? "RETRABALHO" : "EM ANALISE"}

                                    </h1>
                                    <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                                </div>
                                <div className="modal-body">

                                    <div className="text-center py-4">

                                        <div className="mb-4 p-3 rounded" style={{ backgroundColor: "#8FC5CF" }}>
                                            <p className="mb-0 fs-5">
                                                Deseja alterar a peça para {selectedItem.gsA_Status == "Em analise" ? "RETRABALHO" : "EM ANALISE"}?
                                            </p>
                                        </div>

                                        <table className="table table-bordered mx-auto" style={{ maxWidth: "550px" }}>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ width: "40%", padding: "16px" }}>
                                                        Ordem
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {selectedItem.gsA_Ordem}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }}>
                                                        Defeito
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {/* {selectedItem.defeito?.defeito_Descricao.toUpperCase()} */}
                                                        <select value={defect} className="form-select" aria-label="Default select example"
                                                            onChange={(e) => setDefect(e.target.value)}
                                                        >

                                                            <option value="">Selecionar defeito...</option>
                                                            {defects.map(defect2 => (
                                                                <option key={defect2.defeito_Key} value={defect2.defeito_Key}>
                                                                    {defect2.defeito_Descricao}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ width: "40%", padding: "16px" }}>
                                                        Peça
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {selectedItem.informacoes.ordem_Part_Short}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }} >
                                                        Veículo
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }} >
                                                        {selectedItem.informacoes.ordem_VehDesc}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }}>
                                                        Setor
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {selectedItem.informacoes.ordem_SetAtual}
                                                    </td>
                                                </tr>
                                                {
                                                    selectedItem.gsA_Status == "Em analise" &&
                                                    (
                                                        <>
                                                            <tr>
                                                                <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }}>
                                                                    Setor de Retrabalho
                                                                </td>
                                                                <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                                    <div className="w-100 mt-3 h-10">

                                                                        <select value={sector} className="form-select" aria-label="Default select example"
                                                                            onChange={(e) => setSector(e.target.value)}
                                                                        >
                                                                            <option value="" selected>Selecionar setor...</option>
                                                                            {sectors.map(sector2 => {
                                                                                return (
                                                                                    <option key={sector2.setor_Key} value={sector2.setor_Key}>
                                                                                        {sector2.setor_Descricao}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                        Fechar
                                    </button>
                                    <button onClick={(() => reworkGSA(selectedItem))} type="button" className="btn btn-primary">
                                        Confirmar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div >
                )
            }

            {showApproveModal && selectedItem &&
                (
                    <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px', backgroundColor: '#f5f5f5' }}>
                                <div className="modal-body text-center py-5 px-4">

                                    <h2 className="fw-bold mb-4" style={{ color: '#333', fontSize: '1.8rem' }}>
                                        Liberar Peça?
                                    </h2>

                                    <p className="mb-4" style={{ color: '#666', fontSize: '1.1rem', lineHeight: '1.6' }}>
                                        O apontamento deverá ser realizado <strong>MANUALMENTE</strong>.
                                    </p>

                                    <div className="d-flex justify-content-center gap-3 mt-4">

                                        <button type="button" className="btn btn-secondary" onClick={(() => handleCloseApproveModal())}>
                                            Fechar
                                        </button>
                                        <button onClick={(() => approveGSA(selectedItem))} type="button" className="btn btn-success">
                                            Confirmar
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            <TableContainer
                className="mt-3"
                component={Paper}
            >
                <div className="mb-4">
                    <div className="d-flex align-items-center mb-3 p-3 rounded shadow-sm" style={{
                        backgroundColor: "#e3f2fd",
                        borderLeft: "5px solid #2196f3"
                    }}>
                        <i className="bi bi-hourglass-split fs-4 me-3" style={{ color: "#1976d2" }}></i>
                        <h4 className="mb-0 fw-bold" style={{ color: "#1565c0" }}>Em Análise</h4>
                    </div>
                    <TableContainer component={Paper} className="shadow-sm">
                        {tableList("Em analise")}
                    </TableContainer>
                </div>

                <div className="mb-4">
                    <div className="d-flex align-items-center mb-3 p-3 rounded shadow-sm" style={{
                        backgroundColor: "#fff3e0",
                        borderLeft: "5px solid #ff9800"
                    }}>
                        <i className="bi bi-tools fs-4 me-3" style={{ color: "#f57c00" }}></i>
                        <h4 className="mb-0 fw-bold" style={{ color: "#e65100" }}>Retrabalho</h4>
                    </div>
                    <TableContainer component={Paper} className="shadow-sm">
                        {tableList("RETRABALHO")}
                    </TableContainer>
                </div>
            </TableContainer>
        </>
    );
}

export default GSAList;
